import React from "react";
import { Link } from "@remix-run/react";
import { M_URI_FULL_ROOT_PATH } from "~/src/types/openTypes";
import { trackGAClick } from "~/src/logic/GoogleAnalyticsLogic";
import DownloadMobileApp from "~/src/uiblocks/landing/DownloadMobileApp";

const ReadyExploreSmart = () => {
  return (
    <>
      {/* Call to Action */}
      <section className="text-center max-w-5xl mx-auto space-y-4 pt-12 text-gray-800">
        <h2 className="text-3xl font-bold">✨ Ready to explore smarter?</h2>
        <p className="text-lg">Let WayPick create your perfect route.<br />Personalized. Efficient. Effortless.</p>
        {/*<button className="bg-purple-600 text-white rounded-xl px-6 py-3 text-lg hover:bg-purple-700 transition">🟣 Get*/}
        {/*  Started*/}
        {/*</button>*/}
        {/*<p className="text-sm text-gray-500 mt-2">No sign-up required. Try to generate a route quickly!</p>*/}

        <DownloadMobileApp/>

        {/*<p className="mt-4 text-lg text-gray-600">*/}
        {/*  Download our mobile app for the best experience.*/}
        {/*</p>*/}

        {/*<div className="pt-8 justify-center">*/}
          {/*<button*/}
          {/*  type="button"*/}
          {/*  onClick={redirectToMobile}*/}
          {/*  className="bg-blue-600 text-white px-8 py-4 rounded-xl font-semibold hover:bg-blue-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"*/}
          {/*>*/}
          {/*  Getting Started*/}
          {/*</button>*/}

          {/*<Link*/}
          {/*  to={M_URI_FULL_ROOT_PATH}*/}
          {/*  onClick={(e) => {*/}
          {/*    trackGAClick("landing", 'lets-plan-a-route');*/}
          {/*  }}*/}
          {/*  // className="inline-block bg-blue-500 text-white px-4 py-2 rounded"*/}
          {/*  className="bg-blue-600 text-white px-8 py-4 rounded-xl font-semibold hover:bg-blue-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"*/}
          {/*>*/}
          {/*  Let's discover*/}
          {/*</Link>*/}

        {/*</div>*/}

      </section>
    </>
  );
}

export default ReadyExploreSmart;